import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'common/components';
import { translate } from 'react-i18next';

class DropdownUser extends PureComponent {
  static propTypes = {
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
    }).isRequired,
  };

  render = () => (
    <li className="dropdown">
      <a>
        <i className="fa fa-user fa-lg" />
        {this.props.user.name} {this.props.user.lastname}
        <i className="fa fa-angle-down" />
      </a>
      <ul className="dropdown-menu">
        <li>
          <Form.Link to={'/auth/update_info'}>
            <span className="badge ">
              <i className="fa fa-user fa-lg" />
            </span>
            {this.props.t('menu.actions.update')}
          </Form.Link>

          <Form.Link to={'/auth/logout'}>
            <span className="badge badge-danger">
              <i className="fa fa-power-off" />
            </span>
            {this.props.t('menu.actions.logout')}
          </Form.Link>
        </li>
      </ul>
    </li>
  );
}

export default translate()(DropdownUser);



// WEBPACK FOOTER //
// src/modules/secured/components/layout/nav/DropdownUser.js